export default {
  errorColor: "#FF3739",
  bgWhite: "#fff",
  black: "rgba(0, 0, 0, 0.9)",
  black3: "#333333",
  tradexBlue: "#0A57FF",
  tradexBlue1: "rgba(10, 87, 255, 0.1)",
  yesColor: "rgb(38, 92, 255)",
  noColor: "rgb(170, 0, 255)",
  yesColorInactive: "rgba(38, 92, 255, 0.1)",
  noColorInactive: "rgba(170, 0, 255, 0.1)",
  grey: "#323232",
  grey1: "#777777",
  grey2: "#747474",
  grey3: "#F8F8F8",
  grey4: "#F2F2F2",
  grey5: "#FAFAFA",
  grey7: "#808080",
  grey8: "#F7F8FA",
  grey9: "rgba(0, 0, 0, 0.10)",
  grey10: "#454745",
  lightgrey: "#949494",
  lightgrey1: "#F3F3F3",
  black1: "#434343",
  black2: "rgba(0, 0, 0, 0.5)",
  black3: "rgba(0, 0, 0, 0.3)",
  blue1: "#0A57FF",
  blue2: "#E1EAFF",
  red: "#E90000",
  green: "#00AA51",
  grey6: "#DDDDDD",
  borderColor: "rgb(224, 224, 224)",
  orange: "#FF7731",
  purple: "#AA00FF",
  chipBackground: "#F5F5F5",

  //new theme Color
  golden: "rgb(252, 191, 57)",
  blueP4: "#5037BF",
  greenP4: "rgb(93, 255, 150)",
  disableBtnGrey: "rgba(123, 103, 227, 0.20)",
  disableBtnTextColor: "#FCFCFC80",

  //mymaster
  mblue: "#1B2A85",
  mgrey: "rgba(252, 252, 255, 0.60)",
  mNoColor: "#F53838",
  mYesColor: "#27AE60",
  mgrey1: "#DCDCDC",
};
